import { useActions } from '../../hooks';
import { addCampaign, updateCampaign, deleteCampaign } from '../../api';
import type { CampaignType } from '../../api';
import type { CampaignCreatePayload, CampaignUpdatePayload } from '../../api';

export const useCampaignActions = (onRefresh: () => void) => {
  return useActions<CampaignType, CampaignCreatePayload, CampaignUpdatePayload>(
    {
      name: 'Campaign',

      onAdd: addCampaign,
      onEdit: updateCampaign,
      onDelete: deleteCampaign,
      onRefresh,
    }
  );
};

export type FormType = Partial<CampaignCreatePayload>;
